/* eslint-disable import/prefer-default-export */
export const DEVICE_TYPE = 'DEVICE_TYPE';
export const IS_TABLET = 'IS_TABLET';
export const REGION_TYPE = 'REGION_TYPE';
export const CONFIG_KEYS = 'CONFIG_KEYS';
export const CURRENT_ROUTE = 'CURRENT_ROUTE';
export const PAGE_URL = 'PAGE_URL';
export const PAGE_QUERY = 'PAGE_QUERY';
export const GLOBAL_DATA_FAILURE = 'GLOBAL_DATA_FAILURE';
export const CHECK_AUTH = 'CHECK_AUTH';
export const CHECK_AUTH_SUCCESS = 'CHECK_AUTH_SUCCESS';
export const SET_USER_STATE = 'SET_USER_STATE';
export const GET_USER_STATE = 'GET_USER_STATE';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const LOGIN_COOKIE = 'WatersGreetingCookie';
export const RECENTLY_SEARCHED_KEY = 'waters.recentsearches';
export const EPROC_RECENTLY_SEARCHED_KEY = 'waters.eprocRecentsearches';
export const PAGE_ORIGIN = 'PAGE_ORIGIN';
export const SET_ANNOUNCEMENT_DATA = 'ANNOUNCEMENT_DATA';
export const SET_SPECIAL_ANNOUNCEMENT_DATA = 'SET_SPECIAL_ANNOUNCEMENT_DATA';

export const USER_STATE_LOGGED_IN = 'LOGGED_IN';
export const USER_STATE_RECOGNIZED = 'RECOGNIZED';
export const USER_STATE_ANONYMOUS = 'ANONYMOUS';
export const USER_TYPE_ANONYMOUS = 'anonymous';
export const UPDATE_SESSION_EMAIL = 'UPDATE_SESSION_EMAIL';
export const GET_APPLICATION_LABELS = '@XT/APP/GET_APPLICATION_LABELS';
export const GET_APPLICATION_PAGE_DATA = '@XT/APP/GET_APPLICATION_PAGE_DATA';
export const GET_ORDER_SUMMARY_DATA = 'GET_ORDER_SUMMARY_DATA';
export const GET_APPLICATION_LABELS_SUCCESS = '@XT/APP/GET_APPLICATION_LABELS_SUCCESS';
export const GET_ORDER_SUMMARY_DATA_SUCCESS = 'GET_ORDER_SUMMARY_DATA_SUCCESS';
export const GET_ORDER_SUMMARY_DATA_ERROR = 'GET_ORDER_SUMMARY_DATA_ERROR';
export const GET_PROMO_CODE_DETAILS = 'GET_PROMO_CODE_DETAILS';
export const GET_PROMO_CODE_DETAILS_SUCCESS = 'GET_PROMO_CODE_DETAILS_SUCCESS';
export const GET_APPLICATION_PAGE_DATA_SUCCESS = '@XT/APP/GET_APPLICATION_PAGE_DATA_SUCCESS';
export const GET_APPLICATION_LABELS_FAILURE = '@XT/APP/GET_APPLICATION_LABELS_FAILURE';
export const SET_GLOBAL_NOTIFICATION_STATUS = 'SET_GLOBAL_NOTIFICATION_STATUS';
export const SET_GLOBAL_ERROR = 'SET_GLOBAL_ERROR';
export const REMOVE_GLOBAL_ERROR = 'REMOVE_GLOBAL_ERROR';
export const COUNTRY_CODE_KEY = 'localeCountry';
export const LOCALE_KEY = 'localeLanguage';
export const DEFAULT_COUNTRY_CODE = 'us';
export const DEFAULT_LOCALE = 'en';
export const HIDE_GLOBAL_ERROR = 'HIDE_GLOBAL_ERROR';
export const SET_LOADER_STATUS = 'SET_LOADER_STATUS';
export const LOAD_COUNTRY_DATA = 'LOAD_COUNTRY_DATA';
export const LOAD_COUNTRY_DATA_SUCCESS = 'LOAD_COUNTRY_DATA_SUCCESS';
export const LOAD_COUNTRY_DATA_FAILURE = 'LOAD_COUNTRY_DATA_FAILURE';
export const LOAD_SHOPPING_CART_FAILURE = 'LOAD_SHOPPING_CART_FAILURE';
export const LOAD_SHOPPING_CART_DATA = 'LOAD_SHOPPING_CART_DATA';
export const LOAD_SHOPPING_CART_DATA_SUCCESS = 'LOAD_SHOPPING_CART_DATA_SUCCESS';
export const PLACE_ORDER_SUCCESS = 'PLACE_ORDER_SUCCESS';
export const SET_COUNTRY_STATUS_SUCCESS = 'SET_COUNTRY_STATUS_SUCCESS';
export const SET_COUNTRY_STATUS_FAILURE = 'SET_COUNTRY_STATUS_FAILURE';
export const GET_COUNTRY_STATUS = 'GET_COUNTRY_STATUS';
export const SET_SWITCH_ACCOUNT = 'SET_SWITCH_ACCOUNT';
export const USER_ADDRESS_TYPE = 'mailingAddress';
export const SET_EPROC_APP = 'SET_EPROC_APP';
export const ADD_QUOTE_DETAILS = 'ADD_QUOTE_DETAILS';
export const ADD_QUOTE_TO_ORDER_ADDRESS_SUCCESS = 'ADD_QUOTE_TO_ORDER_ADDRESS_SUCCESS';
export const CLEAR_QUOTE_DATA = 'CLEAR_QUOTE_DATA';
export const QUOTE_ORDER_SUCCESS = 'QUOTE_ORDER_SUCCESS';
export const RESET_COUPON_ERROR_DATA = 'RESET_COUPON_ERROR_DATA';
export const SYSTEM_NOTIFICATION = 'SYSTEM_NOTIFICATION';
export const SYSTEM_NOTIFICATION_CLOSE = 'SYSTEM_NOTIFICATION_CLOSE';
export const SYSTEM_NOTIFICATION_SUCCESS = 'SYSTEM_NOTIFICATION_SUCCESS';
export const SYSTEM_NOTIFICATION_FAILURE = 'SYSTEM_NOTIFICATION_FAILURE';
export const LOAD_USER_EMAIL = 'LOAD_USER_EMAIL';
export const SET_FREIGHT_CHARGE_MODAL_STATUS = 'SET_FREIGHT_CHARGE_MODAL_STATUS';
export const SUBMIT_FREIGHT_CHARGE_MODAL = 'SUBMIT_FREIGHT_CHARGE_MODAL';
export const SHORT_TERM_TOKEN_EXPIRED = 'SHORT_TERM_TOKEN_EXPIRED';
export const USER_AUTHORIZATION = 'USER_AUTHORIZATION';
export const USER_AUTHORIZATION_SUCCESS = 'USER_AUTHORIZATION_SUCCESS';
export const SET_SHIPPING_INFO = 'SET_SHIPPING_INFO';
export const USER_AUTHENTICATION = 'USER_AUTHENTICATION';
export const USER_AUTHENTICATION_CLEAR = 'USER_AUTHENTICATION_CLEAR';
export const SET_END_SESSION_MODAL_STATUS = 'SET_END_SESSION_MODAL_STATUS';
export const UPDATE_PAGE_DATA_WITH_V2NAV_DATA = 'UPDATE_PAGE_DATA_WITH_V2NAV_DATA';
export const LOAD_EMPTY_CART = 'LOAD_EMPTY_CART';
export const UPDATE_CUSTOM_PRICING = 'UPDATE_CUSTOM_PRICING';
export const PRODUCT_RECOMMENDATION = 'PRODUCT_RECOMMENDATION';
export const PRODUCT_RECOMMENDATION_TITLE = 'PRODUCT_RECOMMENDATION_TITLE';
export const TRIGGER_ORDER_REVIEW_EVENT = 'TRIGGER_ORDER_REVIEW_EVENT';
export const CREATE_SETUP_INTENT_ID = 'CREATE_SETUP_INTENT_ID';
export const CREATE_SETUP_INTENT_ID_SUCCESS = 'CREATE_SETUP_INTENT_ID_SUCCESS';
export const CREATE_SETUP_INTENT_ID_FAILURE = 'CREATE_SETUP_INTENT_ID_FAILURE';
export const CLEAR_SETUP_INTENT_ID_DATA = 'CLEAR_SETUP_INTENT_ID_DATA';

// session storage Key
export const USER_ID_KEY = 'waters.userDetails';
export const SOLD_TO_KEY = 'waters.soldToDetails';
export const PUNCHOUT_SETUP = 'waters.punchoutSetupDetails';
export const QUOTE_ID_KEY = 'waters.quoteId';
export const PHONE_NUMBER = 'contactPhoneNumber';
export const BUILDING_NUMBER = 'buildingDepartment';
export const PO_NUMBER = 'purchaseOrderNumber';
export const ATTENTION_TO = 'attentionTo';
export const FREIGHT_CHARGE_DETAILS = 'waters.freightChargeDetails';
export const DEFAULT_FREIGHT_DETAILS = 'waters.defaultFreightDetails';

// local storage key
export const SET_STORAGE_CART_ID = 'waters.cartId';
export const SET_STORAGE_CART_GUID = 'waters.cartGuid';
export const SET_SIGN_IN_REDIRECT_KEY = 'waters.signInRedirect';
export const DISMISS_SYSTEM_NOTIFICATION_STORAGE = 'waters.dismissSystemWideNotification';
export const DISMISS_SYSTEM_NOTIFICATION_STORAGE_VALUE = 'Y';

export const ORDER_CONFIRMATION_URL = 'order-confirmation';
export const CART_URL = 'cart';
export const QUICK_ORDER_URL = 'quick-order';
export const CHECKOUT_URL = 'checkout';
export const CHECKOUT_URL_2 = 'checkout-review';
export const QUOTE_CONFIRMATION_URL = 'quote-confirmation';
export const CREATE_QUOTE_URL = 'create-quote';
export const NOT_FOUND_URL = 'not-found';

// Waters Router Path setting
export const DEFAULT_PATH_FORMAT = '/context/localeCountry/localeLanguage/template';
export const SHOPPING_CART = `/store/:localeCountry/:localeLanguage/${CART_URL}`;
export const CHECKOUT = `/store/:localeCountry/:localeLanguage/${CHECKOUT_URL}`;
export const REVIEW_CHECKOUT = `/store/:localeCountry/:localeLanguage/${CHECKOUT_URL_2}`;
export const QUICK_ORDER = `/store/:localeCountry/:localeLanguage/${QUICK_ORDER_URL}`;
export const ORDER_CONFIRMATION = `/store/:localeCountry/:localeLanguage/${ORDER_CONFIRMATION_URL}`;
export const QUOTE_CONFIRMATION = `/store/:localeCountry/:localeLanguage/${QUOTE_CONFIRMATION_URL}`;
export const NOT_FOUND = `/store/:localeCountry/:localeLanguage/${NOT_FOUND_URL}`;
export const CREATE_QUOTE = `/store/:localeCountry/:localeLanguage/${CREATE_QUOTE_URL}`;
export const QUOTE_HISTORY = `/nextgen/{localeCountry}/{localeLanguage}/account/my-account.html#quotehistory`;

export const PAGE_TO_DISABLE_FOOTER_SELECTOR = [
  CHECKOUT_URL,
  QUOTE_CONFIRMATION_URL,
  ORDER_CONFIRMATION_URL,
];

// Country status values
export const FULL_ENABLED = 'FULL_ENABLED';
export const DISABLED = 'DISABLED';
export const PARTIAL_ENABLED = 'PARTIAL_ENABLED';

export const SIGN_OUT = 'SIGN_OUT';

export const ACCEPTED_CREDIT_CARDS = {
  VISA: 'VISA',
  AMEX: 'AMEX',
  MAST: 'MAST',
  DISC: 'DISC',
};

export const NEW_ERROR_CODE = {
  WAT_ERR_907: 'WAT_ERR_907',
  WAT_ERR_028: 'WAT_ERR_028',
  WAT_ERR_906: 'WAT_ERR_906',
  WAT_ERR_154: 'WAT_ERR_154',
  WAT_ERR_382: 'WAT_ERR_382',
  WAT_ERR_000: 'WAT_ERR_000',
  WAT_ERR_0001: 'WAT_ERR_0001',
  WAT_ERR_0005: 'WAT_ERR_0005',
  WAT_ERR_0006: 'WAT_ERR_0006',
  WAT_ERR_0007: 'WAT_ERR_0007',
  WAT_ERR_500: 'WAT_ERR_500',
  WAT_ERR_117: 'WAT_ERR_117',
  WAT_ERR_046: 'WAT_ERR_046',
  WAT_ERR_1001: 'WAT_ERR_1001', // cart not found
  WAT_ERR_STR01: 'WAT_ERR_STR01', // Payment card limit exceeded
  WAT_ERR_STR02: 'WAT_ERR_STR02', // Payment Processing Error.
  WAT_ERR_STR03: 'WAT_ERR_STR03', // Payment processing error.  Please try again later.
};

// Error Codes
export const ERROR_CODE = {
  ...NEW_ERROR_CODE,
  WAT_COUPON: 'WAT_COUPON', // coupon
  WAT_SAP_028: 'WAT_SAP_028', // product
  WAT_ERR_400: 'WAT_ERR_400', // generic
  WTR_ERR_001: 'WTR_ERR_001', // cart not found
  WAT_PRICE_001: 'WAT_PRICE_001',
  WAT_SAP_907: 'WAT_SAP_907', // product
  WAT_SAP_906: 'WAT_SAP_906', // invalid sku
  WAT_IMAGE_001: 'WAT_IMAGE_001',
  WAT_IMAGE_PRODUCT_001: 'WAT_IMAGE_PRODUCT_001',
  WAT_SAP_382: 'WAT_SAP_382', // product unavailable,
  WAT_SAP_154: 'WAT_SAP_154',
  WAT_HTTP_500: 'WAT_HTTP_500',
  WAT_SAP_POSTAL_ERR_001: 'WAT_SAP_POSTAL_ERR_001',
  WAT_SAP_000: 'WAT_SAP_000',
  WAT_SAP_117: 'WAT_SAP_117',
};

// Call 1 time user received
export const PUNCHOUT_LOGIN = 'PUNCHOUT_LOGIN';
export const GET_PUNCHOUT_SETUP_DETAILS = 'GET_PUNCHOUT_SETUP_DETAILS';

// Waters Router Path setting for Eproc User
export const EPROC_DEFAULT_PATH_FORMAT = '/context/localeLanguage/template';
export const EPROC_SHOPPING_CART = `/store/:localeLanguage/${CART_URL}`;
export const EPROC_QUICK_ORDER = `/store/:localeLanguage/${QUICK_ORDER_URL}`;
export const EPROC_NOT_FOUND = `/store/:localeLanguage/${NOT_FOUND_URL}`;

// Search bar actions
export const SEARCH_BAR_REQUEST = 'SEARCH_BAR_REQUEST';
export const SEARCH_BAR_REQUEST_SUCCESS = 'SEARCH_BAR_REQUEST_SUCCESS';
export const CLEAR_SEARCH_BAR = 'CLEAR_SEARCH_BAR';
export const SEARCH_BAR_SUBMIT = 'SEARCH_BAR_SUBMIT';
export const SEARCH_BAR_INTERACTION = 'SEARCH_BAR_INTERACTION';
export const PUNCHOUT_SETUP_FAILURE = 'PUNCHOUT_SETUP_FAILURE';
export const SETUP_FAILURE_STATUS_CODE = 400;
export const SESSION_EXPIRED_STATUS_CODE = 804;
// User Roles
export const EPROC_USER_ROLE = 'EPROC';
export const ECOMM_USER_ROLE = 'ECOMM';

export const USER_ADDRESS = 'userAddress';
export const MAILING_ADDRESS_COUNTRY_CODE_KEY = 'mailingAddressCountryCode';
export const userDetailsContract = {
  firstName: '',
  lastName: '',
  dummySoldto: null,
  localeCountry: '',
  localeLanguage: '',
  sapWebUserId: '',
  userId: '',
  salesOrg: '',
  soldToAccounts: [],
  mailingAddressCountryCode: '',
  isoCode: '',
  approvalStatus: '',
  company: '',
  userRole: '',
  encryptedEmail: '',
  employeeCostCenter: '',
  employeeFlag: '',
  employeeType: '',
  softwareManager: '',
  urouser: '',
  sfContactId: '',
  swProfileFlagEnable: '',
  spCustomerId: '',
};

export const countryCommerceConfigContract = {
  countryCommerceConfig: '',
  checkoutDisabled: false,
  explicitAllowPO: '',
  quoteDisabled: false,
  includeTaxWithPrice: false,
  showFaPiaoHistory: false,
  isGSTEnabled: false,
  isPOAttachmentRequired: false,
  checkoutUpgradeEnabled: false,
  promotionDisabled: false,
  isEprocCountrySelectorEnabled: false,
  SP_PUBLIC_KEY: '',
  allowedCardTypes: '',
  paymentMethodOrder: '',
};
export const stripePaymentAppearance = {
  labels: 'above',
  theme: 'stripe',
  rules: {
    '.Tab': {
      border: '1px solid #E0E6EB',
      padding: '12px',
      boxShadow: 'none',
    },
    '.Tab--selected': {
      boxShadow: 'none',
    },
    '.Tab--selected:focus': {
      boxShadow: 'none',
    },
    '.Input': {
      boxShadow: 'none',
      padding: '15px',
    },
    '.Input:focus': {
      boxShadow: 'none',
    },
    '.Label': {
      textTransform: 'capitalize',
      fontWeight: '500',
    },
    '.Input--invalid': {
      boxShadow: 'none',
      color: '#2D3439',
      fontWeight: '300',
    },
    '.CheckboxLabel': {
      fontSize: '16px',
      fontWeight: '300',
    },

    '.PickerItem ': {
      fontWeight: '400',
      boxShadow: 'none',
      border: 'none',
    },
    '.Error': {
      fontWeight: '400',
    },
    '.Checkbox': {
      lineHeight: '0',
    },
    '.CheckboxInput': {
      border: '1px solid #9CA7B0',
      borderRadius: 'none',
    },
    '.Action': {
      fontWeight: '300',
      marginTop: '25px',
      marginLeft: '10px',
    },
    '.PickerAction ': {
      marginTop: '25px',
      marginLeft: '10px',
      boxShadow: 'none',
    },
    '.PickerItem--selected': {
      boxShadow: 'none',
      border: `1px solid #e0e6eb`,
    },
  },
  variables: {
    colorPrimary: '#0570de',
    colorBackground: '#ffffff',
    colorText: '#30313d',
    colorDanger: '#E60F33',
    fontFamily: 'Acumin Pro,Ideal Sans, system-ui, sans-serif',
    borderRadius: '6px',
    fontWeightLight: '300',
    fontWeightMedium: '400',
    fontWeightNormal: '400',
    fontWeightBold: '400',
    fontSizeBase: '16px',
    spacingUnit: '8px',
  },
};

export const COUNTRY_CONFIG_SUCCESS = 'COUNTRY_CONFIG_SUCCESS';
export const POST_ASTERISK_COUNTRY_CODES = ['jp'];
export const DISABLED_CART_MESSAGE = 'disabledCartMessage';
export const DISABLED_ORDER_ENABLE_QUOTE_MESSAGE = 'disabledOrderEnableQuoteMessage';
export const QUOTE_PAGE_CONTEXT = 'quote';

export const ASIAN_COUNTRY = {
  JP: 'jp',
  CN: 'cn',
  TW: 'tw',
  KR: 'kr',
};

export const siteKey = '6Ld5WMIUAAAAACZQvEc7I75aEg5AC8YUUO0W7zRG';

export const ERROR_STATUS_CODE = {
  ERROR_403: 403,
};
export const TTL = 600000;
export const INDIA_COUNTRY_CODE = 'in';
export const GST_BANNER_MESSAGE_LABEL = 'gstBannerMessage';
export const ALL = 'all';
export const CART_RECOMMENDATIONS_ID = 'cart-recommendations';
